import { render, staticRenderFns } from "./FichaTecnica.vue?vue&type=template&id=7eb89d6a&scoped=true&"
import script from "./FichaTecnica.vue?vue&type=script&lang=js&"
export * from "./FichaTecnica.vue?vue&type=script&lang=js&"
import style0 from "./FichaTecnica.vue?vue&type=style&index=0&id=7eb89d6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb89d6a",
  null
  
)

export default component.exports